import { Box, styled } from '@mui/material';

export const AppointmentsOverviewPageContainer = styled(Box)({
  display: 'flex',
  height: '100%',
  overflow: 'hidden'
});

export const AppointmentsOverviewContentArea = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  minWidth: 0,
  padding: theme.spacing(4)
}));
